import { InfinitePagination } from '@funtech-int/rival';
import { useSignal } from '@funtech-int/rival-react';
import React, { FC } from 'react';
import { InView } from 'react-intersection-observer';

import { PageSpinner } from '@/shared/components/PageSpinner';

interface SentinelProps {
    pagination: InfinitePagination;
}

/**
 * @deprecated Prefer use ScrollSentinel from '@/shared/components/ScrollSentinel/ScrollSentinel.tsx'
 */
export const InfiniteScrollSentinel: FC<SentinelProps> = ({ pagination }) => {
    const status = useSignal(pagination.status);

    const onShow = (inView: boolean) => {
        if (status === 'idle' && inView) {
            pagination.fetch();
        }
    };

    return status === 'loading' ? (
        <PageSpinner loadMore />
    ) : (
        <InView rootMargin="200px" onChange={onShow} />
    );
};
